export default {
  buttons: {
    back: 'Voltar',
  },
};
